import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import {
  IReqApartParams,
  IReqBpartParams,
  IAddKeywordsApart,
  IApartAddDelKeywordParams,
  IApartAddAllKeywordParams,
  IBpartTrackedColorParams,
  IBpartTrackedAlarmParams,
  IBpartTrackedDeleteParams,
  IBpartTrackedLiveSuggestParams,
  IBpartTrackedSuggestPopupAddDelParams,
  IBpartKeywordDelParams,
} from '@models/keyword/keywordModel';
import { KeywordTracking } from '@classes/responseModel/analyzeKeyword/keywordTracking';

// ApartRequest
export const fetchApartKeywordDataList = createAsyncThunk(
  'fetchApartKeywordDataList',
  async (params: IReqApartParams) => {
    try {
      // TODO: 아래의 로직은 추후 API 에 따라 변경하기
      const { userId, apartTabType, tabTypeObj } = params;
      // tabType 별 switch 문을 만들어서 따로 요청해도 됨
      if (apartTabType !== 'Add_Keywords') {
        const { data, status } = await axiosDummyInstance.get(
          [
            '/api/keyword/ApartCompetitorsKeyword.json',
            '/api/keyword/ApartKeywordData1.json',
            '/api/keyword/ApartKeywordData2.json',
          ][Math.floor(Math.random() * 2)],
          { params }
        );

        if (status === 200) {
          return data;
        }
      }
    } catch (error) {
      console.log('fetchApartKeywordDataListError: ', error);
    }
  }
);

// BpartRequest
export const fetchBpartKeywordDataList = createAsyncThunk(
  'fetchBpartKeywordDataList',
  async (params: IReqBpartParams) => {
    try {
      //TODO: 아래의 로직은 추후 API 에 따라 변경하기
      const { tabType } = params;
      console.log('tabType: ', tabType);
      if (tabType === 'Competition_Analysis') {
        const { data, status } = await axiosDummyInstance.get('/api/keyword/BpartCompetitorKeyword.json', { params });
        if (status === 200) {
          console.log('data123: ', data);
          return data;
        }
      } else {
        const { data, status } = await axiosDummyInstance.get('/api/keyword/BpartTrackingData.json', { params });
        if (status === 200) {
          console.log('data456: ', data);
          return new KeywordTracking(data).getBpartTrackedKeywords();
        }
      }
    } catch (error) {
      console.log('fetchBpartKeywordDataListError: ', error);
    }
  }
);

// Apart Add/Del Request
export const fetchApartReqAddDelKeyword = createAsyncThunk(
  'fetchApartReqAddDelKeyword',
  async (params: IApartAddDelKeywordParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        const { bpartTabType } = params;
        // TODO: 성공시 bpart Data 요청처리
        if (bpartTabType === 'Competition_Analysis') {
          const { data: bpartData, status: bpartStatus } = await axiosDummyInstance.get(
            '/api/keyword/BpartCompetitorKeyword.json',
            { params }
          );
          if (bpartStatus === 200) {
            console.log('bpartStatus Competition_Analysis: ', bpartStatus);
            return {
              bpartData,
              params,
            };
          }
        } else {
          const { data: bpartData, status: bpartStatus } = await axiosDummyInstance.get(
            '/api/keyword/BpartTrackingData.json',
            { params }
          );
          if (bpartStatus === 200) {
            console.log('bpartStatus: ', bpartStatus);
            return {
              bpartData,
              params,
            };
          }
        }
      }
    } catch (error) {
      console.log('fetchApartReqAddDelKeywordError: ', error);
    }
  }
);

// Apart AddAll Request
export const fetchApartReqAddAllKeyword = createAsyncThunk(
  'fetchApartReqAddAllKeyword',
  async (params: IApartAddAllKeywordParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        const { bpartTabType } = params;
        // TODO: 성공시 bpart Data 요청처리
        if (bpartTabType === 'Competition_Analysis') {
          const { data: bpartData, status: bpartStatus } = await axiosDummyInstance.get(
            '/api/keyword/BpartCompetitorKeyword.json',
            { params }
          );
          if (bpartStatus === 200) {
            return {
              bpartData,
              params,
            };
          }
        } else {
          const { data: bpartData, status: bpartStatus } = await axiosDummyInstance.get(
            '/api/keyword/BpartTrackingData.json',
            { params }
          );
          if (bpartStatus === 200) {
            return {
              bpartData,
              params,
            };
          }
        }
      }
    } catch (error) {
      console.log('fetchApartReqAddAllKeywordError: ', error);
    }
  }
);

// Bpart - Tracked - 컬러 선택 후 팝업 닫기
export const fetchBpartReqColorSelect = createAsyncThunk(
  'fetchBpartReqColorSelect',
  async (params: IBpartTrackedColorParams) => {
    try {
      // 요청
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        return params;
      }
    } catch (error) {
      console.log('fetchBpartReqColorSelectError: ', error);
    }
  }
);

// Bpart - Tracked - 알람 설정 처리하기
export const fetchBpartReqAlarm = createAsyncThunk('fetchBpartReqAlarm', async (params: IBpartTrackedAlarmParams) => {
  try {
    const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
    if (status === 200) {
      // 성공 시 알람 alert 띄워줌!
      alert('alert set Complete!');

      return params;
    }
  } catch (error) {
    console.log('fetchBpartReqAlarmError: ', error);
  }
});

// Bpart - Tracked - 등록된 keyword 삭제 처리하기
// TODO: 기존 코드.. 1개만 삭제시 처리
//
export const fetchBpartReqDelete = createAsyncThunk(
  'fetchBpartReqDelete',
  async (params: IBpartTrackedDeleteParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        return params;
      }
    } catch (error) {
      console.log('fetchBpartReqDeleteError: ', error);
    }
  }
);
// Bpart - Tracked - 등록된 keyword 삭제 처리하기 (다중 keyword 삭제처리 함수)
// TODO: 이번에 바꾼 코드 (추후 fetchBpartReqDelete 함수는 삭제처리할것)
export const fetchBpartReqKeywordDelete = createAsyncThunk(
  'fetchBpartReqKeywordDelete',
  async (params: IBpartKeywordDelParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        return params;
      }
    } catch (error) {
      console.log('fetchBpartReqKeywordDelete Error: ', error);
    }
  }
);

// Bpart - Tracked - Live 팝업 창 띄우기 && 데이터 요청
export const fetchBpartReqLivePopup = createAsyncThunk(
  'fetchBpartReqLivePopup',
  async (params: IBpartTrackedLiveSuggestParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/keyword/BpartLivePopupData.json', { params });
      if (status === 200) {
        return {
          liveData: data,
          params: params,
        };
      }
    } catch (error) {
      console.log('fetchBpartReqLivePopupError: ', error);
    }
  }
);

// Bpart - Tracked - Suggest 팝업 창 띄우기 && 데이터 요청
export const fetchBpartReqSuggestPopup = createAsyncThunk(
  'fetchBpartReqSuggestPopup',
  async (params: IBpartTrackedLiveSuggestParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/keyword/BpartSuggestPopupData.json', { params });
      if (status === 200) {
        return {
          suggestData: data,
          params: params,
        };
      }
    } catch (error) {
      console.log('fetchBpartReqSuggestPopupError: ', error);
    }
  }
);

// Bpart - Tracked - Suggest add/del 처리
export const fetchBpartSuggestPopupAddDel = createAsyncThunk(
  'fetchBpartSuggestPopupAddDel',
  async (params: IBpartTrackedSuggestPopupAddDelParams) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        return params;
      }
    } catch (error) {
      console.log('fetchBpartSuggestPopupAddDelError: ', error);
    }
  }
);
